export const GET_COMPANY_USERS_REQUEST = 'GET_COMPANY_USERS_REQUEST';
export const GET_COMPANY_USERS_SUCCESS = 'GET_COMPANY_USERS_SUCCESS';
export const GET_COMPANY_USERS_FAILURE = 'GET_COMPANY_USERS_FAILURE';

// DEPRECATED
export const SET_COMPANY = 'SET_COMPANY';
